var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Số điện thoại ")]),_c('b-input',{attrs:{"type":"text","placeholder":"Nhập số điện thoại..."},model:{value:(_vm.entry.phone),callback:function ($$v) {_vm.$set(_vm.entry, "phone", $$v)},expression:"entry.phone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }